var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 6.1875H5.0625C3.81986 6.1875 2.8125 7.19486 2.8125 8.4375V12.9375C2.8125 14.1801 3.81986 15.1875 5.0625 15.1875H12.9375C14.1801 15.1875 15.1875 14.1801 15.1875 12.9375V8.4375C15.1875 7.19486 14.1801 6.1875 12.9375 6.1875Z",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 6.1875H12.9375C13.5342 6.1875 14.1065 6.42455 14.5285 6.84651C14.9504 7.26847 15.1875 7.84076 15.1875 8.4375C15.1875 9.03424 14.9504 9.60653 14.5285 10.0285C14.1065 10.4504 13.5342 10.6875 12.9375 10.6875H5.0625C4.46576 10.6875 3.89347 10.4504 3.47151 10.0285C3.04955 9.60653 2.8125 9.03424 2.8125 8.4375C2.8125 7.84076 3.04955 7.26847 3.47151 6.84651C3.89347 6.42455 4.46576 6.1875 5.0625 6.1875V6.1875Z",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 2.8125H10.6875C11.1351 2.8125 11.5643 2.99029 11.8807 3.30676C12.1972 3.62322 12.375 4.05245 12.375 4.5V6.1875H5.625V4.5C5.625 4.05245 5.80279 3.62322 6.11926 3.30676C6.43572 2.99029 6.86495 2.8125 7.3125 2.8125V2.8125Z",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolebtn);
export default __webpack_public_path__ + "static/media/rolebtn.64f7508f0144b970aaa2b73a6a051b3e.svg";
export { ForwardRef as ReactComponent };